import { theme } from 'antd';
import { EditIcon } from 'assets/images/svg';
import { changePassword } from 'library/firebase/fb.auth.utils';
import { useState } from 'react';
import { Notification } from 'zComponents/atoms';
import { Button, Divider, Flex, Form, Input, Modal, Tooltip, Typography } from 'zui/Antd';
const { Title } = Typography;
function ChangePasswordModal({ children, open, setOpen, personID }) {
	const {
		token: { paddingLG, paddingSM, fontWeightStrong, paddingXL, colorBorderSecondary }
	} = theme.useToken();
	const [form] = Form.useForm();

	const [internalVisible, setInternalVisible] = useState(false);
	const [loading, setLoading] = useState(false);

	const visible = open || internalVisible;
	const setVisible = setOpen || setInternalVisible;

	const newPassword = Form.useWatch('newPassword', form);

	const handleCancel = () => {
		setVisible(false);
		form.resetFields();
	};

	const handleSubmit = async (values) => {
		try {
			setLoading(true);
			const result = await changePassword({
				currentPassword: values.currentPassword,
				newPassword: values.newPassword
			});

			if (result.success) {
				Notification('success', result.message);
				handleCancel();
			} else {
				Notification('error', result.message);
			}
		} catch (error) {
			Notification('error', 'An unexpected error occurred. Please try again.');
			console.error('Password change error:', error);
		} finally {
			setLoading(false);
		}
	};
	return (
		<>
			<Tooltip title='Change Password' placement='top'>
				{children ? (
					children
				) : (
					<Button icon={<EditIcon />} onClick={() => setVisible(true)}>
						Change Password
					</Button>
				)}
			</Tooltip>

			<Modal
				open={visible}
				onCancel={handleCancel}
				closable
				centered
				destroyOnClose
				width={768}
				footer={[
					<>
						<Divider
							style={{
								color: colorBorderSecondary,
								margin: `${paddingXL}px -${paddingXL}px`,
								width: `calc(100% + ${paddingXL * 2}px)`
							}}
						/>

						<Flex align='center' justify='flex-end' gap={paddingSM} key='footer'>
							<Button onClick={handleCancel} type='default' disabled={loading}>
								Cancel
							</Button>
							<Button type='primary' form='change-password-form' htmlType='submit' loading={loading}>
								Change Password
							</Button>
						</Flex>
					</>
				]}
				styles={{ content: { padding: paddingXL } }}
			>
				<Flex vertical style={{ marginBottom: paddingLG }}>
					<Title level={4} style={{ margin: 0 }}>
						Change Password
					</Title>
				</Flex>

				<Form id='change-password-form' form={form} layout='vertical' onFinish={handleSubmit}>
					<Form.Item
						name='currentPassword'
						label='Current Password'
						validateFirst
						rules={[
							{ required: true, message: 'Please enter your current password' },
							{ min: 8, message: 'Password must be at least 8 characters' }
						]}
						style={{ fontWeight: fontWeightStrong }}
						required={false}
					>
						<Input.Password placeholder='Enter current password' />
					</Form.Item>

					<Form.Item
						name='newPassword'
						label='New Password'
						validateFirst
						rules={[
							{ required: true, message: 'Please enter your new password' },
							{ min: 8, message: 'Password must be at least 8 characters' }
						]}
						style={{ fontWeight: fontWeightStrong }}
						required={false}
					>
						<Input.Password placeholder='Enter new password' />
					</Form.Item>

					<Form.Item
						name='confirmNewPassword'
						label='Confirm New Password'
						validateFirst
						dependencies={['newPassword']}
						rules={[
							{ required: true, message: 'Please re confirm new password' },
							{ min: 8, message: 'Password must be at least 8 characters' },
							() => ({
								validator(_, value) {
									if (!value || !newPassword || newPassword === value) {
										return Promise.resolve();
									}
									return Promise.reject(new Error('Passwords do not match'));
								}
							})
						]}
						style={{ fontWeight: fontWeightStrong }}
						required={false}
					>
						<Input.Password placeholder='Enter new password again' />
					</Form.Item>
				</Form>
			</Modal>
		</>
	);
}

export default ChangePasswordModal;
